export function HomeFooter() {
  return (
    <footer className="home-footer">
      <div className="home-footer-bottom">
        <img
          src="/logo-horizontal-mono-light.svg"
          alt="Beleidssignaal"
          className="home-footer-logo"
          width="360"
          height="64"
        />
        <span className="home-footer-copy">
          © {new Date().getFullYear()} Beleidssignaal. Op tijd weten welk beleid eraan komt.
        </span>
      </div>
    </footer>
  );
}
